import React from "react";
import { Card, Row, Col, Tooltip, Button } from "antd";
import TenantsImg from "../../../assets/images/totalTenants.png";
import UsersImg from "../../../assets/images/totalUser.png";
import PodcastImg from "../../../assets/images/totalPodcast.png";
import { DownloadOutlined } from "@ant-design/icons";
import { Link } from "react-router";

const DashboardCards = ({ count, countLoading, downloadPDF, pieChart }) => {
  
  const cardData = [
    {
      title: "Total Users",
      value: `${count?.user_count}`,
      icon: <img src={TenantsImg} alt={TenantsImg} />,
      color: "#48B7D614",
      link: '/user-management'
      
    },
    {
      title: "Active Users",
      value:  `${count?.active_user}`,
      icon: <img src={UsersImg} alt={UsersImg} />,
      color: "#FFA60014",
       link: '/user-management',
       data: true,
    },
    {
      title: "Total Podcasts",
      value: `${count?.total_podcast}`,
      icon: <img src={PodcastImg} alt={PodcastImg} />,
      color: "#45AE5114",
       link: '/manage-podcast',
      
    },
    // {
    //   title: "Most Popular Category",
    //   value: "News & Media",
    //   icon: <img src={MostPopularImg} alt={MostPopularImg} />,
    //   color: "#1E413314",
    // },
  ];

  const dataset = () => {
    localStorage.setItem('firstLoad', "firstLoad")
  }

  return (
    <Row gutter={[16, 16]}>
      {cardData.map((item, index) => (
        <Col xs={24} sm={12} md={12} lg={6} key={index}>
          <Link 
          to={item.link}
          
          onClick={item?.data ? dataset : ''}
  >
          <Card
            style={{
              borderRadius: 15,
              padding: 0,
            }}
            loading={countLoading}
            bodyStyle={{ padding: 0 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="leftBx">
                <p>{item.title}</p>
                <h3 style={{ margin: 0 }}>{item.value}</h3>
              </div>

              <div className="icon" style={{ backgroundColor: item.color }}>
                <span>{item.icon}</span>
              </div>
            </div>
          </Card>
          </Link>
        </Col>
      ))}
      <Col xs={24} sm={12} md={12} lg={6}>
        <div className="d-flex justify-end no-print">
          {/* <Tooltip title="Download Dashboard Report"> */}
          <Button
            onClick={downloadPDF}
            icon={<DownloadOutlined />}
            type="primary"
          >
            Download Pdf
          </Button>
          {/* </Tooltip> */}
        </div>
      </Col>
    </Row>
  );
};

export default DashboardCards;
